import React, { FC, useEffect } from 'react';
import useScrollToSection from '@hooks/useScrollToSection';
import useTranslations from '@hooks/useTranslation';
import Title, { TitleTagTypes } from '@ui/SectionTitle/Title';
import ContentTemplate from '../../ui/Content/Content';
import TeamPersonTemplate from '../../ui/TeamPerson/TeamPerson';
import { Persons } from './Team.elements';

export interface TeamProps { }

export const TEAMS = [
    {
        image: '/team_person1.webp',
        name: 'Mária Puškárová',
        position: 'Riaditeľka vzdelávania',
        phones: [] as string[],
        mail: 'puskarova@pp.sk',
    },
    {
        image: '/team_person3.webp',
        name: 'Viera Šinská',
        position: 'Manažérka služieb zákazníkom',
        phones: ['+421 41 7053 414', '+421 918 451 113'],
        mail: 'sinska@pp.sk',
    },
    {
        image: '/team_person4.webp',
        name: 'Daniela Šmehylová',
        position: 'Špecialistka pre on-line vzdelávanie',
        phones: ['+421 41 7053 263', '+421 918 450 980'],
        mail: 'smehylovad@pp.sk',
    },
    {
        image: '/team_lenka.webp',
        name: 'Lenka Kupčaková',
        position: 'Špecialistka pre rozvoj vzdelávania',
        phones: ['+421 41 7053 262', '+421 905 510 415'],
        mail: 'kupcakova@pp.sk',
    },
    {
        image: '/team_person6.webp',
        name: 'Lívia Krištofová',
        position: 'Event manažérka',
        phones: ['+421 41 7053 269', '+421 918 450 986'],
        mail: 'kristofova@pp.sk',
    },
    {
        image: '/team_person13.webp',
        name: 'Dominika Chládeková',
        position: 'Odborná referentka vzdelávania',
        phones: ['+421 41 7053 261', '+421 908 876 312'],
        mail: 'chladekova@pp.sk',
    },
    {
        image: '/team_kubickova.webp',
        name: 'Petra Kubičková',
        position: 'Špecialistka pre internetový marketing',
        phones: [],
        mail: 'kubickova@pp.sk',
    },
    {
        image: '/team_person11.webp',
        name: 'Jakub Mičuch',
        position: 'Video špecialista',
        phones: [],
        mail: 'micuch@pp.sk',
    },
    {
        image: '/team_person12.webp',
        name: 'Tomáš Lazár',
        position: 'Video špecialista',
        phones: [],
        mail: 'lazar@pp.sk',
    },
    {
        image: '/team_person15.png',
        name: 'Matej Strýček',
        position: 'Odborný referent vzdelávania',
        phones: [],
        mail: 'strycek@pp.sk',
    }
];

const TeamTemplate: FC<TeamProps> = () => {
    const { t } = useTranslations();

    useScrollToSection('nas-tym', 'nastym');

    return (
        <ContentTemplate withPadding id="nastym" mobileSidePadding={20}>
            <Title tagType={TitleTagTypes.H3} isBlack>
                {t('contact.team.title')}
            </Title>
            <Persons>
                {TEAMS.map((person, personKey) => (
                    <TeamPersonTemplate
                        key={personKey}
                        personKey={personKey}
                        image={person.image}
                        name={person.name}
                        position={person.position}
                        phones={person.phones}
                        mail={person.mail}
                    />
                ))}
            </Persons>
        </ContentTemplate>
    );
};

export default TeamTemplate;
